"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregators = void 0;
const Average_1 = require("./Average");
const Count_1 = require("./Count");
const GroupConcat_1 = require("./GroupConcat");
const Max_1 = require("./Max");
const Min_1 = require("./Min");
const Sample_1 = require("./Sample");
const Sum_1 = require("./Sum");
exports.aggregators = {
    count: Count_1.Count,
    sum: Sum_1.Sum,
    min: Min_1.Min,
    max: Max_1.Max,
    avg: Average_1.Average,
    group_concat: GroupConcat_1.GroupConcat,
    sample: Sample_1.Sample,
};
//# sourceMappingURL=index.js.map